/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  permission.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:23
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import router from './router'
import store from './store'
import { whitePathList } from '@/core/pageConfig'
import { getUserMenus } from '@/api/sys-auth'
import { checkIsCoreEnterprice, haveAuditPermission } from '@/api/customerManage'

router.beforeEach((to, from, next) => {
  // 如果url带了op=edit的话，就改变meta.title中的新增为编辑
  if (to.meta.title) {
    if (to.fullPath.includes('op=edit')) {
      to.meta.title = to.meta.title.replace('新增', '修改')
    } else {
      to.meta.title = to.meta.title.replace('修改', '新增')
    }
  }

  /* 分享模块的页面不做token校验 */
  if (whitePathList.includes(to.path)) {
    next()
  } else {
    if ((store.state.user.token && !store.getters.roles.length) || to.query.refreshToken === '1') {
      // 获取菜单
      getUserMenus().then((res) => {
        const menus = res.data.find((i: any) => i.actionName === 'SupplyTechApp')
        store.commit('SET_ROLES', [menus])
        // 生成路由（权限也在这里添加进路由）
        store.dispatch('GenerateRoutes', { menus })
      }).finally(() => {
        next()
      })
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
})
